module.exports = __webpack_public_path__ + "img/ihidv.dbbbd8d0.svg";